<template>
  <nav class="navbar navbar-expand-md navbar-light bg-light">
        <div class="container-fluid">
            <a class="navbar-brand" href="#" @click="$emit('ToRoot')"><img src="../../public/static/image/logo.png"
                width="45" height="45"></a>
            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav"
                aria-controls="navbarNav" aria-expanded="false" aria-label="Переключатель навигации">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarNav">
                <ul class="navbar-nav">
                    <li v-if="!loginOk" class="nav-item">
                        <a class="nav-link" aria-current="page" href="https://api.bormart.ru/login/?origin=www.bormart.ru">Вход</a>
                    </li>
                    <li v-if="!loginOk" class="nav-item">
                        <a @click="$emit('RegBtn')" class="nav-link" aria-current="page" href="#">Регистрация</a>
                    </li>
                    <li v-if="loginOk" class="nav-item">
                        <a class="nav-link" aria-current="page" href="#"><strong>{{username}}</strong></a>
                    </li>
                    <li v-if="loginOk & (role >> 0) & 1" class="nav-item">
                        <a @click="$emit('ToRoot')" class="nav-link" aria-current="page" href="#">Новости</a>
                    </li>
                    <li v-if="loginOk & (role >> 0) & 1" class="nav-item">
                        <a @click="$emit('ToFiles')" class="nav-link" aria-current="page" href="#">Файлы</a>
                    </li>
                    <li v-if="loginOk & (role >> 2) & 1" class="nav-item">
                        <a @click="$emit('WebCamBtn')" class="nav-link" aria-current="page" href="#">Видеонаблюдение</a>
                    </li>
                    <li v-if="loginOk & (role >> 1) & 1" class="nav-item">
                        <a @click="$emit('RadioCompBtn')" class="nav-link" aria-current="page" href="#">Реестр компонентов</a>
                    </li>
                    <li v-if="loginOk & (role >> 3) & 1" class="nav-item">
                        <a @click="$emit('UsersBtn')" class="nav-link" aria-current="page" href="#">Пользователи</a>
                    </li>
                    <li v-if="loginOk & (role >> 4) & 1" class="nav-item">
                        <a @click="$emit('NewsEditBtn')" class="nav-link" aria-current="page" href="#">Редактор новостей</a>
                    </li>
                    <li v-if="loginOk" class="nav-item">
                        <a @click="$emit('LogoutBtn')" class="nav-link" aria-current="page" href="#">Выйти</a>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
</template>

<script>
export default {
  name: 'NavBar',
  props: {
    loginOk: Boolean,
    username: String,
    role: Number
  }
}
</script>